import { useSyncExternalStore } from "react";
import { isCapacityIncomplete } from "@/api/trainingGpu";
import { gpuCapacityController } from "./gpuCapacityController";

/**
 * 클러스터 GPU 총 수(`total_allocatable_gpus`)다. 사이드바 위젯이 15초마다 받는 스냅샷을 그대로
 * 읽는다. 그래서 요청을 늘리지 않는다. 아직 읽지 못했거나(첫 로드 전·실패) 응답이 불완전하면
 * null 이다. 그때 0 을 "GPU 없음"으로 읽으면 안 된다.
 */
export function useGpuCapacityTotal(): number | null {
  // 스냅샷 객체가 아니라 총 수(원시값)를 구독한다. 그래서 15초 폴링이 같은 값을 새 객체로 반환해도
  // 구독자(제출 위저드 전체)가 다시 그리지 않는다.
  return useSyncExternalStore(gpuCapacityController.subscribe, readTotalGpus, readTotalGpus);
}

function readTotalGpus(): number | null {
  const data = gpuCapacityController.getSnapshot().data;
  // 계약 밖 응답(필드 부재)은 읽지 못한 것으로 판정한다. 위젯과 달리 여기서는 예외를 던지지 않는다.
  if (
    data === null ||
    !Array.isArray(data.errors) ||
    typeof data.total_allocatable_gpus !== "number" ||
    isCapacityIncomplete(data) ||
    data.total_allocatable_gpus <= 0
  ) {
    return null;
  }
  return data.total_allocatable_gpus;
}
